module.exports = __webpack_public_path__ + "static/media/instagram.8e8d554c.svg";